module.exports = __webpack_public_path__ + "static/img/123.0e8f49b6.png";